export default class model_list {
    lists = [];

    constructor() {
        this.watch_lists();
    }

    load_list(list) {
        let actions      = list.querySelector('.actions');
        let data         = this.lists[list.dataset.mlId];
        let filter       = list.querySelector('form.model-list-filter');
        let filter_data  = new FormData(filter);
        let headers      = list.querySelector('thead');
        let results      = list.querySelector('tbody');

        if (list.stream) {
            list.stream.close();
        }

        if (window._GET.page) {
            data.page = window._GET.page;
        }

        results.innerHTML = '';

        list.stream = window.JellyBelly.stream(
            'model-list/get',
            data,
            (json, stop) => {
                if (json.what === 'actions') {
                    actions.innerHTML = json.result.html;
                    data.innerHTML    = json.result.page;
                } else if (json.what === 'headers') {
                    headers.innerHTML = json.result;
                } else if (json.what === 'result') {
                    results.innerHTML += json.result;
                }

                if (stop) {
                    this.watch_actions(list);
                }
            }
        );
    }

    watch_actions(list) {
        let pages = list.querySelectorAll('.page-link');

        pages.forEach(page => {
            page.addEventListener('click', () => {
                let page_number = Number(page.dataset.page);
                let url         = new URL(window.location);

                url.searchParams.set('page', page_number);

                history.pushState({}, '', url);

                window._GET.page = page_number;

                this.load_list(
                    list,
                    {
                        page: page_number
                    }
                );
            });
        });
    }

    watch_lists() {
        let self = this;
        document.querySelectorAll('.model-list').forEach((list, i) => {
            self.lists[i] = {
                export:     list.dataset.export === 'true',
                filter:     {},
                id:         list.dataset.id ? list.dataset.id : '',
                model:      list.dataset.model,
                selects:    list.dataset.selects ? 1 : 0,
                stream:     null,
                list:       list.dataset.list,
                list_class: list.dataset.listClass ? list.dataset.listClass : '',
            };

            list.setAttribute('data-ml-id', i);

            self.load_list(list);
        });
    }
};
